module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/event-date-f460152efbf278eee69850f5f821a882.svg&quot;;"